import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getCustomerById } from "~/lib/api/api-client";
import { Container, Paper, Alert, AlertTitle, CircularProgress, Button, Typography, Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { TransactionForm } from "~/components/TransactionForm";

export default function Redeem() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [customer, setCustomer] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!id) return;
        const fetchData = async () => {
            try {
                const result = await getCustomerById(id);
                if (result.success) {
                    setCustomer(result.customer);
                } else {
                    setError(result.error || "Failed to fetch customer");
                }
            } catch (err: any) {
                setError(err.message || "Failed to fetch customer");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);

    if (loading) {
        return (
            <Container maxWidth="lg" sx={{ p: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                    <CircularProgress size={48} />
                </Box>
            </Container>
        );
    }

    if (error || !customer) {
        return (
            <Container maxWidth="lg" sx={{ p: 2 }}>
                <Paper elevation={2} sx={{ p: 3 }}>
                    <Alert severity="error" sx={{ mb: 2 }}>
                        <AlertTitle>خطأ</AlertTitle>
                        {error || "العميل غير موجود"}
                    </Alert>
                    <Button variant="contained" onClick={() => navigate("/")}>عودة للرئيسية</Button>
                </Paper>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ p: 2 }}>
            <Box sx={{ mb: 2 }}>
                <Button startIcon={<ArrowBack />} variant="text" onClick={() => navigate(`/customer/${id}`)}>
                    رجوع للعميل
                </Button>
            </Box>
            <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h4" sx={{ mb: 1, fontWeight: "bold" }}>
                    خصم نقاط (استبدال)
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6">{customer.name}</Typography>
                    <Typography variant="body1" sx={{ color: "gray" }}>{customer.phone}</Typography>
                    <Typography variant="subtitle1" sx={{ color: "#2196f3", mt: 1 }}>
                        الرصيد: {customer.pointsBalance.toFixed(2)} نقطة
                    </Typography>
                </Box>
                <TransactionForm
                    customer={{ barcode: customer.barcode, pointsBalance: customer.pointsBalance }}
                    onSuccess={() => { }}
                    initialTransactionType="REDEEM_DIRECT"
                    hideTypeSelector={true}
                />
            </Paper>
        </Container>
    );
}
